// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  apiUrl: 'http://localhost:4000',
  primaryURL: 'https://firstdevlab.com/api/v1/',
  baseURL: 'https://firstdevlab.com/api/v1/dispatch/',
  mediaURL: 'https://realestate.ebeanomarket.com/storage/',
  onesignal: {
    appId: '422ae1c7-6a50-4143-b87b-a43bbab8',
    googleProjectNumber: '30042017',
    restKey: 'NThkZTgxNWQtMWIxMS00OWU3LTk2ZDUtMjNhNTFlZDY'
  },
  general: {
    symbol: '₦',
    code: 'NGN'
  },
  authToken: '12345678'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
